import { render, staticRenderFns } from "./ToggleFavoriteButton.vue?vue&type=template&id=4aa8dde4&"
import script from "./ToggleFavoriteButton.vue?vue&type=script&lang=js&"
export * from "./ToggleFavoriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports